export default "__VITE_ASSET__DIgbCgn0__"